var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-group task-shared-users justify-content-start"},[_vm._l((_vm.usersObj.list),function(u,i){return _c('img',{key:`ozpqq_${i}`,staticClass:"img rounded-circle",attrs:{"role":"button","src":u.avator,"alt":""},on:{"click":function($event){return _vm.$emit('on-setting')}}})}),_vm._t("mention")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }